{{#with context}}
if (!uvm_config_db#({{ type }})::get({{#if (not ../useInstName)}}this, "{{ ../instNameOverride }}"{{else}}null, inst_name{{/if}}, "{{ configDbKey }}", {{ identifier }})) begin
  `uvm_fatal(get_type_name(), {"{{ type }} must be set {{#if ../useInstName}}for ", inst_name, " {{/if}}{{#if ../instNameOverride}}for \"{{ ../instNameOverride }}\" {{/if}}using the name \"{{ configDbKey }}\"."})
end
{{/with}}
